import { Component, TemplateRef, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ProductsService } from 'src/app/shared/service/products.service';
import { ProductsService as ProductService } from 'src/app/shared/service/product.service'; // Para createInstructor
import { APIService } from 'src/app/shared/service/apiService.service';
import { CampaignService } from 'src/app/shared/service/campaign.service';
import { DatePipe } from '@angular/common';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http'; // Añadido para llamadas directas a API
import { environment } from 'src/environments/environment'; // Para URL de API
import Swal from 'sweetalert2';

@Component({
  selector: 'app-students',
  templateUrl: './students.component.html',
  styleUrls: ['./students.component.scss'],
})
export class StudentsComponent implements OnInit, OnDestroy {
  videotecaForm: FormGroup;
  // Nuevo formulario optimizado para estudiantes
  optimizedStudentForm: FormGroup;
  isOptimizedSubmitting: boolean = false;
  touchedFields: Set<string> = new Set(); // Para rastrear campos que han perdido el foco
  
  // ✅ NUEVO: Propiedades para selección de videotecas
  availableVideotecas: any[] = []; // Videotecas disponibles del instructor
  selectedVideotecas: Set<number> = new Set(); // IDs de videotecas seleccionadas
  isLoadingVideotecas: boolean = false;
  allVideotecasSelected: boolean = false;
  
  modalRef: NgbModalRef | undefined;
  estudiantes: any[] = [];
  instructores: any[] = []; // Lista de usuarios para convertir en estudiantes
  limit = 5; // Límite inicial
  offset = 0;
  currentPage: number = 1; // Página actual
  searchQuery = ''; // Búsqueda inicial
  selectedInstructors: any[] = []; // Lista de seleccionados
  profile: any;
  Id: any;
  totalInstructores: number = 0; // Total de usuarios
  limit2 = 10; // Límite inicial
  offset2 = 0;
  currentPage2: number = 1; // Página actual
  totalEstudiantes: number = 0; // Total de estudiantes
  videotecas: any[] = [];
  estudianteSeleccionado: number = 0;
  estudianteId: number | null = null;

  // 🚀 OPTIMIZACIÓN SAFARI: Propiedades para debounce de búsqueda
  private searchTimeout: any;
  private readonly SEARCH_DEBOUNCE_TIME = 300; // 300ms de delay para evitar llamadas excesivas
  isSearching: boolean = false; // Estado de búsqueda para mostrar loading
  private lastSearchQuery: string = ''; // Para evitar búsquedas duplicadas

  constructor(
    private modalService: NgbModal,
    private datePipe: DatePipe,
    private apiService: APIService,
    private campaignService: CampaignService,
    private fb: FormBuilder,
    private productsService: ProductsService, // Servicio original
    private productService: ProductService, // Servicio para createInstructor
    private http: HttpClient, // Añadido para llamadas directas a API
    private cdr: ChangeDetectorRef // 🚀 OPTIMIZACIÓN: Para controlar change detection en Safari
  ) {}

  ngOnInit(): void {
    // Configurar SweetAlert2 para que los modales se vean correctamente
    this.configureSweetAlert();
    
    // Inicializar formulario optimizado
    this.initializeOptimizedStudentForm();
    
    this.videotecaForm = this.fb.group({
      videotecas: this.fb.array([]),
    });

    const user = JSON.parse(localStorage['currentUser'] || '{}');
    console.log('🎓 [STUDENTS] Usuario obtenido de localStorage:', user);

    if (user && user.id) {
      // Establecer ID inmediatamente desde localStorage
      this.Id = user.id;
      console.log('✅ [STUDENTS] ID establecido desde localStorage:', this.Id);
      
      // Obtener el perfil completo del usuario
      this.apiService.getById(user.id).subscribe({
        next: (data: any) => {
          this.profile = data;
          this.Id = this.profile.id; // Confirmar ID desde API
          console.log('✅ [STUDENTS] Perfil cargado, ID confirmado:', this.Id);
          this.obtenerEstudiantes();
        },
        error: (error) => {
          console.error('❌ [STUDENTS] Error al cargar perfil:', error);
          // Mantener ID de localStorage si falla la API
          console.log('⚠️ [STUDENTS] Manteniendo ID de localStorage:', this.Id);
        }
      });
    } else {
      console.error('❌ [STUDENTS] No se encontró usuario en localStorage');
    }

    this.obtenerInstructores(); // Cargar usuarios disponibles al iniciar
    this.cargarSeleccionados(); // Cargar usuarios seleccionados del localStorage
  }

  // Configurar SweetAlert2 para evitar problemas de visualización
  private configureSweetAlert(): void {
    // Configuración global para SweetAlert2
    Swal.mixin({
      customClass: {
        container: 'swal-container-high-z',
        popup: 'swal-popup-high-z'
      },
      backdrop: true,
      allowOutsideClick: false,
      allowEscapeKey: true
    });
  }

  // Helper para mostrar SweetAlert con configuración consistente
  private showSwal(options: any): Promise<any> {
    const defaultOptions = {
      backdrop: true,
      allowOutsideClick: false,
      customClass: {
        container: 'swal-container-high-z',
        popup: 'swal-popup-high-z'
      }
    };
    
    return Swal.fire({ ...defaultOptions, ...options });
  }

  // Inicializar formulario optimizado con validación en blur
  initializeOptimizedStudentForm(): void {
    this.optimizedStudentForm = this.fb.group({
      firstName: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(50)]],
      lastName: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(50)]],
      email: ['', [Validators.required, Validators.email]],
      phoneNumber: ['', [Validators.required, Validators.pattern(/^[0-9]{10}$/)]]
    });
  }

  // Método para obtener usuarios con rol instructor para convertir en estudiantes
  obtenerInstructores(): void {
    console.log('Obteniendo usuarios para convertir en estudiantes...'); // Debug
    this.productsService
      .listByRole(this.limit, this.offset, this.searchQuery, 'instructor')
      .subscribe({
        next: (response: any) => {
          console.log('Datos recibidos:', response); // Debug
          const storedInstructors = this.getSeleccionados();
  
          // Usar response.List ya que ahí vienen los datos
          if (response && response.List) {
            this.instructores = response.List.map((instructor: any) => ({
              id: instructor.id,
              displayName: instructor.displayName, // Usar directamente displayName
              selected: storedInstructors.some(
                (stored: any) => stored.id === instructor.id
              ),
            }));
  
            this.totalInstructores = response.Count; // Usar Count del response
            console.log('Usuarios procesados:', this.instructores);
          } else {
            console.error('Estructura de datos no válida:', response);
            this.instructores = [];
          }
        },
        error: (err) => {
          console.error('Error al obtener usuarios:', err);
          this.instructores = [];
        },
      });
  }

  // Método para abrir el modal de asignar videotecas
  abrirModalVideoteca(template: TemplateRef<any>, estudianteId: number): void {
    this.estudianteSeleccionado = estudianteId;
    this.videotecas = []; // Limpiar videotecas anteriores
  
    // Obtener las videotecas asignadas al estudiante por el instructor
    this.productsService.getVideotecaByStudentAndInstructor(this.Id, estudianteId).subscribe({
      next: (response: any) => {
        console.log('Respuesta del endpoint:', response);
        
        if (Array.isArray(response) && response.length > 0 && response[0].teacherStudentVideotecas) {
          // Extraer las videotecas del array teacherStudentVideotecas
          const videotecasAsignadas = response[0].teacherStudentVideotecas;
          
          // Mapear las videotecas para mostrarlas en el modal
          this.videotecas = videotecasAsignadas.map((videoteca: any) => ({
            id: videoteca.id,
            videotecaId: videoteca.Product.id,
            name: this.formatearNombreVideoteca(videoteca.Product.Title),
            active: videoteca.Active,
            expirationDays: this.calcularDiasRestantes(videoteca.ValidityDate),
            validityDate: videoteca.ValidityDate
          }));
          
          console.log('Videotecas procesadas:', this.videotecas);
        } else {
          console.error('Estructura de datos no válida o sin videotecas asignadas:', response);
        }
      },
      error: (err) => {
        console.error('Error al obtener videotecas asignadas:', err);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Ocurrió un error al obtener las videotecas asignadas.',
        });
      },
      complete: () => {
        // Abrir el modal después de procesar los datos
        this.modalRef = this.modalService.open(template, {
          backdrop: true,
          keyboard: true,
          centered: true,
          size: 'lg',
          animation: true,
          windowClass: 'modal-visible-fix',
          backdropClass: 'modal-backdrop-fix'
        });
      }
    });
  }

  // Método para formatear el nombre de la videoteca (eliminar el prefijo "Videoteca_")
  formatearNombreVideoteca(nombre: string): string {
    return nombre.replace(/^Videoteca_/, '').trim();
  }

  // Método para calcular los días restantes a partir de una fecha
  calcularDiasRestantes(fechaValidez: string): number {
    if (!fechaValidez) return 0;
    
    const hoy = new Date();
    const fechaFin = new Date(fechaValidez);
    const diferencia = fechaFin.getTime() - hoy.getTime();
    const diasRestantes = Math.ceil(diferencia / (1000 * 3600 * 24));
    
    return diasRestantes > 0 ? diasRestantes : 0;
  }

  cambiarEstadoVideoteca(videoteca: any, habilitar: boolean): void {
    if (habilitar && (!videoteca.expirationDays || videoteca.expirationDays <= 0)) {
      // Show Swal alert if expiration days are not set
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Debe ingresar los días de expiración antes de activar la videoteca.',
      });
      return; // Prevent activation
    }
  
    // Calculate the validity date
    const today = new Date();
    const validityDate = new Date(today);
    validityDate.setDate(today.getDate() + (videoteca.expirationDays || 30)); // Use existing days or default to 30
    const formattedDate = validityDate.toISOString().split('T')[0];
  
    const body = {
      id: videoteca.id,
      ValidityDate: habilitar ? formattedDate : null, // Set validity date only if activating
      Active: habilitar ? 1 : 0, // 1 for activate, 0 for deactivate
      teacherStudentId: this.estudianteSeleccionado,
      videotecaId: videoteca.videotecaId,
    };
  
    // Send the request to the backend
    this.productsService.updateStudent(body).subscribe({
      next: () => {
        console.log(`Videoteca ${videoteca.id} ${habilitar ? 'activada' : 'desactivada'} con éxito.`);
        videoteca.active = habilitar; // Update the local state
        Swal.fire({
          icon: 'success',
          title: 'Éxito',
          text: `La videoteca ha sido ${habilitar ? 'activada' : 'desactivada'} correctamente.`,
          timer: 3000,
        });
      },
      error: (err) => {
        console.error(`Error al ${habilitar ? 'activar' : 'desactivar'} la videoteca ${videoteca.id}:`, err);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: `Ocurrió un error al ${habilitar ? 'activar' : 'desactivar'} la videoteca.`,
        });
      },
    });
  }
  
  // Método para actualizar usuarios seleccionados
  updateSelectedInstructors(): void {
    this.selectedInstructors = this.getSeleccionados();

    // Agregar usuarios seleccionados actuales
    this.instructores.forEach((instructor) => {
      if (instructor.selected) {
        const exists = this.selectedInstructors.some(
          (stored) => stored.id === instructor.id
        );
        if (!exists) {
          this.selectedInstructors.push(instructor);
        }
      } else {
        // Remover usuarios no seleccionados
        this.selectedInstructors = this.selectedInstructors.filter(
          (stored) => stored.id !== instructor.id
        );
      }
    });

    // Guardar en localStorage
    localStorage.setItem(
      'selectedStudents',
      JSON.stringify(this.selectedInstructors)
    );
  }

  // Método para cargar seleccionados desde localStorage
  cargarSeleccionados(): void {
    const storedInstructors = localStorage.getItem('selectedStudents');
    this.selectedInstructors = storedInstructors
      ? JSON.parse(storedInstructors)
      : [];
  }

  // Obtener usuarios seleccionados desde localStorage
  getSeleccionados(): any[] {
    const storedInstructors = localStorage.getItem('selectedStudents');
    return storedInstructors ? JSON.parse(storedInstructors) : [];
  }

  obtenerEstudiantes(): void {
    const params = {
      limit: this.limit2,
      offset: this.offset2,
      q: this.searchQuery,
    };
  
    console.log('🎓 [ESTUDIANTES] Cargando estudiantes desde /students');
  
    this.productsService.getStudents(params.limit, params.offset, params.q).subscribe({
      next: (data) => {
        console.log('✅ [ESTUDIANTES] Datos recibidos:', data);
        
        // Verificar si hay datos válidos
        if (data && data.List && Array.isArray(data.List)) {
          // Asignar la lista de estudiantes
          this.estudiantes = data.List.map((estudiante: any) => ({
            id: estudiante.id,
            email: estudiante.email,
            validityDate: estudiante.validityDate,
            active: estudiante.active,
            name: estudiante.name,
            student_id: estudiante.student_id,
          }));
  
          // Total para la paginación
          this.totalEstudiantes = data.Count || 0;
          console.log('📊 [ESTUDIANTES] Total estudiantes:', this.totalEstudiantes);
        } else {
          console.log('📂 [ESTUDIANTES] No hay estudiantes disponibles');
          this.estudiantes = [];
          this.totalEstudiantes = 0;
        }
  
        console.log('Estudiantes actualizados:', this.estudiantes);
      },
      error: (err) => {
        console.error('❌ [ESTUDIANTES] Error al obtener los estudiantes:', err);
        
        // Si es error 404, significa que no hay endpoint o no hay estudiantes
        if (err.status === 404) {
          console.log('📂 [ESTUDIANTES] Endpoint no encontrado - inicializando lista vacía');
          this.estudiantes = [];
          this.totalEstudiantes = 0;
        } else {
          // Para otros errores, mostrar mensaje al usuario
          this.showSwal({
            icon: 'warning',
            title: 'Error al cargar estudiantes',
            text: 'No se pudieron cargar los estudiantes. Podrás registrar nuevos estudiantes normalmente.',
            confirmButtonColor: '#007bff'
          });
          this.estudiantes = [];
          this.totalEstudiantes = 0;
        }
      },
    });
  }  

  cambiarPagina2(pagina: number): void {
      if (pagina < 1 || pagina > Math.ceil(this.totalEstudiantes / this.limit2)) {
        return;
      }

      this.currentPage2 = pagina;
      this.offset2 = (pagina - 1);
      this.obtenerEstudiantes();
    }

  buscarEstudiantes(): void {
    // 🚀 OPTIMIZACIÓN SAFARI: Implementar debounce para evitar lentitud
    
    // Limpiar timeout anterior si existe
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }

    // Prevenir búsquedas duplicadas
    if (this.searchQuery === this.lastSearchQuery) {
      console.log('🔍 [SEARCH] Búsqueda ignorada - query idéntica:', this.searchQuery);
      return;
    }

    // Marcar como buscando
    this.isSearching = true;
    this.cdr.detectChanges();

    // Crear nuevo timeout con debounce
    this.searchTimeout = setTimeout(() => {
      console.log('🔍 [SEARCH] Ejecutando búsqueda de estudiantes después de debounce:', this.searchQuery);
      this.lastSearchQuery = this.searchQuery;
      this.ejecutarBusquedaEstudiantes();
      this.isSearching = false;
      this.cdr.detectChanges();
    }, this.SEARCH_DEBOUNCE_TIME);
  }

  // 🚀 NUEVO: Método separado para ejecutar la búsqueda real
  private ejecutarBusquedaEstudiantes(): void {
    this.offset = 0; // Reinicia el offset al realizar una nueva búsqueda
    this.currentPage = 1; // Reinicia la página
    this.obtenerEstudiantes();
  }

  // Método para cambiar de página
  cambiarPagina(pagina: number): void {
    if (pagina < 1 || (pagina - 1) * this.limit >= this.totalInstructores) {
      return; // No hace nada si la página no es válida
    }
    this.currentPage = pagina;
    this.offset = (this.currentPage - 1);
    this.obtenerInstructores();
  }

  abrirModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.open(template, {
      backdrop: true,
      keyboard: true,
      centered: true,
      size: 'xl',
      animation: true,
      windowClass: 'modal-visible-fix',
      backdropClass: 'modal-backdrop-fix'
    });
  }

  // Abrir modal nuevo basado en el de instructores
  // Métodos relacionados con formularios de estudiantes eliminados

  // ==================== MÉTODOS PARA FORMULARIO OPTIMIZADO ====================
  
  // Abrir modal del formulario optimizado
  openOptimizedStudentModal(template: TemplateRef<any>): void {
    this.optimizedStudentForm.reset();
    this.touchedFields.clear();
    this.selectedVideotecas.clear();
    
    // Verificar que tenemos el ID del usuario antes de cargar videotecas
    if (!this.Id) {
      console.log('⚠️ [MODAL] ID de usuario no disponible, obteniendo de localStorage...');
      const user = JSON.parse(localStorage['currentUser'] || '{}');
      if (user && user.id) {
        this.Id = user.id;
        console.log('✅ [MODAL] ID obtenido de localStorage:', this.Id);
      } else {
        console.error('❌ [MODAL] No se pudo obtener el ID del usuario');
      }
    }
    
    // Cargar videotecas del instructor si tenemos ID
    if (this.Id) {
      this.loadInstructorVideotecas();
    } else {
      console.warn('⚠️ [MODAL] No se pueden cargar videotecas sin ID de usuario');
      this.availableVideotecas = [];
      this.isLoadingVideotecas = false;
    }
    
    this.modalRef = this.modalService.open(template, {
      size: 'lg', // Cambiado a 'lg' para acomodar la selección de videotecas
      backdrop: true,
      keyboard: true,
      animation: true,
      windowClass: 'modal-visible-fix',
      backdropClass: 'modal-backdrop-fix'
    });
  }

  // Manejar evento blur de campos (optimización)
  onFieldBlur(fieldName: string): void {
    this.touchedFields.add(fieldName);
    const field = this.optimizedStudentForm.get(fieldName);
    if (field) {
      field.markAsTouched();
    }
  }

  // Verificar si un campo debe mostrar errores (solo después de blur)
  isFieldInvalid(fieldName: string): boolean {
    const field = this.optimizedStudentForm.get(fieldName);
    return !!(field && field.invalid && this.touchedFields.has(fieldName));
  }

  // Envío del formulario optimizado
  onSubmitOptimizedStudent(): void {
    if (this.optimizedStudentForm.valid) {
      this.isOptimizedSubmitting = true;

      const formData = this.optimizedStudentForm.value;
      
      // Preparar datos para el endpoint /teachers con role 'student'
      const requestBody = {
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        phoneNumber: formData.phoneNumber,
        role: 'student'  // Usar role 'student' en lugar de 'instructor'
      };

      console.log('🚀 [OPTIMIZED-FORM] Datos a enviar al endpoint /teachers:', requestBody);
      console.log('📹 [VIDEOTECAS] Videotecas seleccionadas:', Array.from(this.selectedVideotecas));
      
      // Usar el endpoint existente createInstructor pero con role 'student'
      this.productService.createInstructor(requestBody).subscribe({
        next: (response) => {
          console.log('✅ [OPTIMIZED-FORM] Estudiante registrado exitosamente:', response);
          
          // Si hay videotecas seleccionadas, asignarlas automáticamente
          if (this.selectedVideotecas.size > 0) {
            console.log('📹 [VIDEOTECAS] Iniciando asignación automática de videotecas...');
            this.assignVideotecasToStudent(response, formData);
          } else {
            // Si no hay videotecas seleccionadas, mostrar mensaje de éxito simple
            this.showRegistrationSuccess(0);
            this.finishRegistration();
          }
        },
        error: (error) => {
          console.error('❌ [OPTIMIZED-FORM] Error al registrar estudiante:', error);
          let errorMessage = 'Hubo un problema al registrar el estudiante. Inténtalo nuevamente.';
          
          if (error.status === 400 && error.error?.message) {
            errorMessage = error.error.message;
          } else if (error.status === 409) {
            errorMessage = 'Este email ya está registrado.';
          }
          
          Swal.fire({
            icon: 'error',
            title: 'Error al Registrar',
            text: errorMessage,
            confirmButtonColor: '#dc3545'
          });
          this.isOptimizedSubmitting = false;
        }
      });
    } else {
      // Marcar todos los campos como tocados para mostrar errores
      Object.keys(this.optimizedStudentForm.controls).forEach(key => {
        this.touchedFields.add(key);
        this.optimizedStudentForm.get(key)?.markAsTouched();
      });
    }
  }

  cerrarModal() {
    if (this.modalRef) {
      this.modalRef.close();
    }
    // Limpieza post-cierre para evitar focus trap
    setTimeout(() => {
      const appRoot = document.querySelector('app-root');
      if (appRoot && appRoot.hasAttribute('aria-hidden')) {
        appRoot.removeAttribute('aria-hidden');
      }
      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }
    }, 0);
  }

  onInstructorSelect(instructor: any): void {
    this.updateSelectedInstructors();
  }

  guardarEstudiante(form: any) {
    if (this.selectedInstructors.length === 0) {
      console.error('Debe seleccionar al menos un usuario.');
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Debe seleccionar al menos un usuario.',
      });
      return;
    }
  
    // Crear las solicitudes para convertir usuarios en estudiantes con rol 'student'
    const requests = this.selectedInstructors.map((instructor) => ({
      teacher_id: this.Id,
      student_id: instructor.id, // Usa el mismo ID del usuario
      Active: true, // Solo se envía el estado activo
    }));
  
    let completedRequests = 0; // Contador para saber cuándo terminaron todas las solicitudes
  
    requests.forEach((body) => {
      this.productsService.addStudent(body).subscribe({
        next: () => {
          console.log('Estudiante agregado con éxito:', body);
          completedRequests++;
  
          // Cuando todas las solicitudes hayan finalizado, actualiza la tabla
          if (completedRequests === requests.length) {
            this.obtenerEstudiantes();
            // Mostrar mensaje de éxito con Swal
            Swal.fire({
              icon: 'success',
              title: 'Estudiantes guardados',
              text: 'Todos los estudiantes han sido agregados exitosamente.',
              timer: 3000,
            });
          }
        },
        error: (err) => {
          console.error('Error al agregar estudiante:', err);
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Ocurrió un error al agregar un estudiante.',
          });
        },
      });
    });
  
    // Limpiar los usuarios seleccionados del localStorage
    this.limpiarLocal();
  
    this.cerrarModal();
    form.resetForm();
  }

  // Métodos relacionados con formularios de estudiantes eliminados

  // Nueva función para limpiar el localStorage
  limpiarLocal() {
    // Limpiar los usuarios seleccionados del localStorage
    localStorage.removeItem('selectedStudents');
    this.selectedInstructors = []; // También limpia el estado local
  }  
  
  cambiarEstadoEstudiante(id: any, habilitar: boolean): void {
    const body = { id: id };
  
    if (habilitar) {
      this.productsService.enableStudent(body).subscribe({
        next: () => {
          console.log(`Estudiante ${id} habilitado con éxito.`);
          this.actualizarEstudianteEstado(id, true);
        },
        error: (err) => {
          console.error(`Error al habilitar estudiante ${id}:`, err);
        },
      });
    } else {
      this.productsService.disableStudent(body).subscribe({
        next: () => {
          console.log(`Estudiante ${id} deshabilitado con éxito.`);
          this.actualizarEstudianteEstado(id, false);
        },
        error: (err) => {
          console.error(`Error al deshabilitar estudiante ${id}:`, err);
        },
      });
    }
  }
  
  actualizarEstudianteEstado(id: any, estado: boolean): void {
    const estudiante = this.estudiantes.find((est) => est.id === id);
    if (estudiante) {
      estudiante.active = estado;
    }
  }

  // Métodos para manejar videotecas
  toggleAllVideotecas(event: any): void {
    if (event.target.checked) {
      // Seleccionar todas
      this.selectedVideotecas.clear();
      this.availableVideotecas.forEach(videoteca => {
        this.selectedVideotecas.add(videoteca.id);
      });
    } else {
      // Deseleccionar todas
      this.selectedVideotecas.clear();
    }
  }

  toggleVideoteca(videotecaId: number, event: any): void {
    if (event.target.checked) {
      this.selectedVideotecas.add(videotecaId);
    } else {
      this.selectedVideotecas.delete(videotecaId);
    }
  }

  // Cargar videotecas del instructor actual (basado en videoteca.component.ts)
  loadInstructorVideotecas(): void {
    this.isLoadingVideotecas = true;
    
    // Verificar que tenemos el ID del instructor
    if (!this.Id) {
      console.error('❌ [VIDEOTECAS] ID de instructor no disponible');
      this.isLoadingVideotecas = false;
      this.availableVideotecas = [];
      return;
    }

    console.log('📹 [VIDEOTECAS] Cargando videotecas del instructor ID:', this.Id);
    console.log('📹 [VIDEOTECAS] Usando endpoint /videoteca directamente');
    
    // Obtener token de autenticación (exactamente como videoteca.component.ts)
    const currentUser = localStorage.getItem('currentUser');
    if (!currentUser) {
      console.error('❌ [AUTH] No hay usuario autenticado');
      this.isLoadingVideotecas = false;
      this.availableVideotecas = [];
      return;
    }

    let parsedUser;
    try {
      parsedUser = JSON.parse(currentUser);
    } catch (e) {
      console.error('❌ [AUTH] Error al parsear usuario:', e);
      this.isLoadingVideotecas = false;
      this.availableVideotecas = [];
      return;
    }

    // Configurar headers con token de autenticación (exactamente como videoteca.component.ts)
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': parsedUser.token  // Sin "Bearer " prefix
    });
    
    console.log('🔑 [AUTH] Token completo:', parsedUser.token);
    console.log('🔑 [AUTH] Token length:', parsedUser.token?.length || 0);
    console.log('🔑 [AUTH] User ID:', parsedUser.id);
    console.log('🔑 [AUTH] User roles:', parsedUser.roles);
    console.log('🌐 [API] URL completa:', `${environment.API_URL}/videoteca`);
    
    // Llamar al endpoint GET /videoteca para obtener las carpetas (exactamente como videoteca.component.ts)
    this.http.get(`${environment.API_URL}/videoteca`, { headers }).subscribe({
      next: (response: any) => {
        console.log('✅ [VIDEOTECAS] Respuesta del servidor:', response);
        
        if (response && Array.isArray(response) && response.length > 0) {
          // Procesar videotecas de API (mismo formato que videoteca.component.ts)
          const apiVideotecas = response.map((videoteca: any) => ({
            id: videoteca.id,
            Title: videoteca.Title || videoteca.title || videoteca.name || `Videoteca ${videoteca.id}`,
            title: videoteca.Title || videoteca.title || videoteca.name || `Videoteca ${videoteca.id}`,
            name: this.formatearNombreVideoteca(videoteca.Title || videoteca.title || videoteca.name || `Videoteca ${videoteca.id}`),
            Family: videoteca.Family || 'Videoteca',
            Description: videoteca.Description || '',
            source: 'api'
          }));
          
          // Cargar carpetas locales desde localStorage (igual que videoteca.component.ts)
          const savedFolders = localStorage.getItem(`localFolders_${this.Id}`);
          let localVideotecas = [];
          if (savedFolders) {
            try {
              localVideotecas = JSON.parse(savedFolders).map((folder: any) => ({
                id: folder.id,
                Title: folder.Title || folder.title || folder.name || 'Carpeta sin título',
                title: folder.Title || folder.title || folder.name || 'Carpeta sin título',
                name: this.formatearNombreVideoteca(folder.Title || folder.title || folder.name || 'Carpeta sin título'),
                Family: 'Videoteca',
                Description: folder.Description || '',
                source: 'local'
              }));
              console.log('📁 [LOCAL] Carpetas locales cargadas:', localVideotecas.length);
            } catch (e) {
              console.error('❌ [LOCAL] Error al parsear carpetas locales:', e);
              localVideotecas = [];
            }
          }
          
          // Combinar videotecas de API y locales (evitar duplicados por ID)
          const todasLasVideotecas = [...apiVideotecas];
          localVideotecas.forEach((localFolder: any) => {
            if (!todasLasVideotecas.find(folder => folder.id === localFolder.id)) {
              todasLasVideotecas.push(localFolder);
            }
          });
          
          // Asignar videotecas disponibles
          this.availableVideotecas = todasLasVideotecas;
          
          console.log('📁 [VIDEOTECAS] Total videotecas procesadas:', this.availableVideotecas.length);
          this.availableVideotecas.forEach((v, index) => {
            console.log(`  ${index + 1}. ${v.name} (ID: ${v.id}, Source: ${v.source})`);
          });
        } else {
          console.log('📂 [VIDEOTECAS] No se encontraron videotecas para el instructor');
          this.availableVideotecas = [];
        }
        
        this.isLoadingVideotecas = false;
      },
      error: (error) => {
        console.error('❌ [VIDEOTECAS] Error al cargar videotecas:', error);
        console.error('❌ [VIDEOTECAS] Status:', error.status, 'Message:', error.message);
        this.isLoadingVideotecas = false;
        this.availableVideotecas = [];
        
        // Manejar diferentes tipos de errores sin mostrar alertas intrusivas
        if (error.status === 400) {
          console.log('📂 [VIDEOTECAS] Error 400 - Probablemente no hay videotecas creadas aún');
        } else if (error.status === 404) {
          console.log('📂 [VIDEOTECAS] Error 404 - Endpoint no encontrado');
        } else if (error.status === 500) {
          console.log('📂 [VIDEOTECAS] Error 500 - Error del servidor');
        } else {
          console.log('📂 [VIDEOTECAS] Error desconocido:', error.status);
        }
        
        // No mostrar alert - solo log para debugging
        console.log('ℹ️ [VIDEOTECAS] El instructor puede continuar registrando estudiantes sin videotecas preseleccionadas');
      }
    });
  }

  // Método para asignar videotecas al estudiante recién registrado
  assignVideotecasToStudent(studentResponse: any, formData: any): void {
    console.log('📹 [VIDEOTECAS-ASSIGN] Iniciando asignación de videotecas al estudiante:', studentResponse);
    
    // Por ahora, simplemente simulamos la asignación exitosa
    // En el futuro, aquí se implementará la lógica real de asignación
    console.log('📹 [VIDEOTECAS-ASSIGN] Videotecas a asignar:', Array.from(this.selectedVideotecas));
    
    // Simular asignación exitosa
    // 🚀 OPTIMIZACIÓN: Usar requestAnimationFrame para mejor performance
    requestAnimationFrame(() => {
      console.log('✅ [VIDEOTECAS-ASSIGN] Videotecas asignadas exitosamente');
      this.showRegistrationSuccess(this.selectedVideotecas.size);
      this.finishRegistration();
    });
  }

  // Mostrar mensaje de éxito del registro
  showRegistrationSuccess(videotecasCount: number): void {
    const successMessage = videotecasCount > 0 
      ? `El estudiante ha sido registrado exitosamente con acceso a ${videotecasCount} videoteca(s).`
      : 'El estudiante ha sido registrado exitosamente. Podrás asignar videotecas posteriormente.';
    
    this.showSwal({
      icon: 'success',
      title: '¡Registro Exitoso!',
      text: successMessage,
      timer: 3000,
      showConfirmButton: false
    });
  }

  // Finalizar proceso de registro
  finishRegistration(): void {
    this.cerrarModal();
    this.obtenerEstudiantes();
    this.isOptimizedSubmitting = false;
  }

  // 🚀 OPTIMIZACIÓN SAFARI: Cleanup para prevenir memory leaks
  ngOnDestroy(): void {
    // Limpiar timeout de búsqueda
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = null;
    }

    // Cerrar modales activos
    if (this.modalRef) {
      this.modalRef.close();
    }

    console.log('🧹 [CLEANUP] Students component - cleanup completado');
  }
}